import type { LucideIcon } from 'lucide-react';
import { Card } from '../components/ui/Card';

export function ComingSoon({ icon: Icon, title, integrationLabel }: { icon: LucideIcon; title: string; integrationLabel: string }) {
  return (
    <Card className="flex flex-col items-center gap-3 p-14 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-slate-100 text-slate-400 dark:bg-slate-800">
        <Icon size={22} />
      </div>
      <h2 className="text-lg font-semibold text-slate-800 dark:text-white">{title}</h2>
      <p className="max-w-sm text-sm text-slate-400">
        The {integrationLabel} integration client isn&apos;t wired up on the server yet. This page is scaffolded and
        will populate automatically once that API client is added to the backend.
      </p>
    </Card>
  );
}
